import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Conta } from 'src/app/models/financeiro/conta.model';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from "../vos/auth.service";

@Injectable({
    providedIn: 'root'
})
export class ContaService {
    // UrlConta = 'https://madelife.med.br:3399/api/contas';
    constructor(private http: HttpClient, private authService: AuthService) { }

    getAll(): Observable<Conta[]> {
        return this.http.get<Conta[]>(`${URL_GLOBAL}/contas`);
    }

    save(data: any, token): Observable<any> {
        return this.http.post<any>(`${URL_GLOBAL}/contas`, data, { headers: this.authService.userToken() });
    }

    find(id: any): Observable<any> {
        return this.http.get(`${`${URL_GLOBAL}/contas`}/${id}`);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put<any>(`${`${URL_GLOBAL}/contas`}/${id}`, data);
    }

    destroy(id: any): Observable<any> {
        return this.http.delete<any>(`${`${URL_GLOBAL}/contas`}/${id}`);
    }
    PegarTodosOsRegistrosPorIdDaEmpresa(param: any): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/contas`, { params: new HttpParams().append("commands", JSON.stringify(param)) });
    }
}
